import { render, staticRenderFns } from "./TableProgram.vue?vue&type=template&id=8b84028c&"
import script from "./TableProgram.vue?vue&type=script&lang=js&"
export * from "./TableProgram.vue?vue&type=script&lang=js&"
import style0 from "./TableProgram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
